import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { set_vendor_store } from "../../../../redux/actions/StoreAction";
import ProductCard from "./ProductCard";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper/core";

import "swiper/swiper.scss";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

import "./productlist.scss";

const screenBreakpoints = {
  md: 768,
  lg: 992,
  xl: 1024,
  xxl: 1200,
  xxxl: 1440,
};

SwiperCore.use([Pagination, Navigation]);

const ProductList = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  window.addEventListener("resize", handleWindowSizeChange);

  const productCountPerSlideView = () => {
    if (width >= screenBreakpoints.xxxl) {
      return 5;
    } else if (width >= screenBreakpoints.xxl) {
      return 5;
    } else if (width >= screenBreakpoints.xl) {
      return 4;
    } else if (width >= screenBreakpoints.lg) {
      return 3;
    } else if (width >= screenBreakpoints.md) {
      return 3;
    } else {
      return 5;
    }
  };

  return (
    <Fragment>
      <div className="product-list-desktop">
        <div className="product-list-container mx-auto">
          <Swiper
            spaceBetween={0}
            slidesPerView={productCountPerSlideView()}
            pagination={{
              clickable: true,
            }}
            navigation={true}
          >
            {props.product &&
              props.product.map((product) => {
                return (
                  <SwiperSlide key={product.id}>
                    <ProductCard
                      key={product.id}
                      type={props.type}
                      product={product}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return { vendorStore: state.vendorStore.vendorStore };
};

const mapDispatchTopProps = {
  set_vendor_store,
};

export default connect(mapStateToProps, mapDispatchTopProps)(ProductList);
